// extracted by mini-css-extract-plugin
module.exports = {"recipient":"recipient__72HLi","recipientDragging":"recipientDragging__1MYR3"};